/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramAuthTelegramControllerAuthorizeByTelegramWidgetDataMutationRequest,
  TelegramAuthTelegramControllerAuthorizeByTelegramWidgetDataMutationResponse,
  TelegramAuthTelegramControllerAuthorizeByTelegramWidgetData401,
  TelegramAuthTelegramControllerAuthorizeByTelegramWidgetData403,
} from '../../types/TelegramAuthTelegramControllerAuthorizeByTelegramWidgetData.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramAuthTelegramAuthorizeByTelegramWidgetData } from '../../methods/telegramAuthTelegramAuthorizeByTelegramWidgetData.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramAuthTelegramAuthorizeByTelegramWidgetDataMutationKey = () =>
  [{ url: '/api/telegram/auth/telegram/login-widget' }] as const;

export type TelegramAuthTelegramAuthorizeByTelegramWidgetDataMutationKey = ReturnType<
  typeof telegramAuthTelegramAuthorizeByTelegramWidgetDataMutationKey
>;

/**
 * {@link /api/telegram/auth/telegram/login-widget}
 */
export function useTelegramAuthTelegramAuthorizeByTelegramWidgetData<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramAuthTelegramControllerAuthorizeByTelegramWidgetDataMutationResponse,
      ResponseErrorConfig<
        | TelegramAuthTelegramControllerAuthorizeByTelegramWidgetData401
        | TelegramAuthTelegramControllerAuthorizeByTelegramWidgetData403
      >,
      { data: TelegramAuthTelegramControllerAuthorizeByTelegramWidgetDataMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramAuthTelegramControllerAuthorizeByTelegramWidgetDataMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramAuthTelegramAuthorizeByTelegramWidgetDataMutationKey();

  return useMutation<
    TelegramAuthTelegramControllerAuthorizeByTelegramWidgetDataMutationResponse,
    ResponseErrorConfig<
      | TelegramAuthTelegramControllerAuthorizeByTelegramWidgetData401
      | TelegramAuthTelegramControllerAuthorizeByTelegramWidgetData403
    >,
    { data: TelegramAuthTelegramControllerAuthorizeByTelegramWidgetDataMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramAuthTelegramAuthorizeByTelegramWidgetData(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
